import { Component } from 'react';
import { connect, Dispatch } from 'react-redux';
import { IFollowUpSurveyCounts } from '@nkr/models/follow-up';
import { AppActionCreators, FollowUpActionCreators, IApplicationState, IAppState, IFollowUpSurveyCountsResponse } from '@nkr/store/index';
import FollowUpSurveyList from './list';
import SurveyNav from './nav';

interface IProps {
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    itemId?: number,
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getFollowUpSuveyCounts: (centerId: number) => Promise<IFollowUpSurveyCountsResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    counts: IFollowUpSurveyCounts,
}

class SurveyContainer extends Component<TProps, IState> {
    readonly state: IState = {
        counts: {
            centerId: -1, allToDo: 0, allPending: 0, pendingSurvey: 0, pendingReview: 0,
            pendingAppointment: 0, pendingLabOrder: 0, pendingLabResults: 0, completeNoResults: 0,
            pendingNotifyDonor: 0, complete: 0, incomplete: 0, all: 0
        },
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting survey counts, one moment please...').then(() => {
            this.props.getFollowUpSuveyCounts(this.props.centerId).then(response => {
                this.setState({
                    counts: response.data.results
                });

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        return (
            <>
                <SurveyNav
                    counts={this.state.counts}
                    activeKey={this.props.activeKey}
                    isAdmin={this.props.isAdmin}
                    isNkrLogin={this.props.isAdminLogin}
                    centerId={this.props.centerId}
                />

                <FollowUpSurveyList
                    centerId={this.props.centerId}
                    activeKey={this.props.activeKey}
                    isAdmin={this.props.isAdmin}
                    isAdminLogin={this.props.isAdminLogin}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        // app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getFollowUpSuveyCounts: (centerId) => {
            return dispatch(FollowUpActionCreators.getSurveyCounts(centerId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(SurveyContainer);